<ng-template #annotationTpl let-source="source">
	@let layout = getAnnotationLayout(source.data.boundingBox);
	<div
		class="pos-abs pe-none chunk-annotation"
		[attr.data-source-id]="source.id"
		[class.chunk-annotation--normalized]="layout.normalized"
		[style.--bbTop]="layout.top"
		[style.--bbLeft]="layout.left"
		[style.--bbWidth]="layout.width"
		[style.--bbHeight]="layout.height"
	>
		<div
			class="w-100 h-100 bg-primary-20 br-0q chunk-highlight"
			[class.invisible]="$highlightOnly() && $selectedSourceId().id !== source.id"
		></div>

		@if (!$highlightOnly()) {
			<div
				class="pos-abs pos-t-0 pos-l-0 fl fl-ai-c fl-jc-c"
				style="transform: translateX(calc(-100% - (0.5 * var(--spacing))))"
			>
				<div class="w-sp-2 h-sp-2 fs-xxs br-circle bg-primary fc-white fl fl-ai-c fl-jc-c">
					{{ source.inlineNumber }}
				</div>
			</div>

			<button
				tooltip="Translate"
				class="translation-button fl-ai-c fl-jc-c pe-all p-0h br-1 shadow-1"
				(click)="translateChunk(source)"
			>
				<i class="icon-translations" [class.fc-icon-s]="$smallScreen()"></i>
			</button>
		}
	</div>
</ng-template>

<ng-template #separator>
	<div class="w-px-1 ov-h fl fl-ai-c fl-jc-c">
		<div buttonIcon size="S" [disabled]="true">
			<div class="h-fs-icon w-px-1 line-230-as-bg"></div>
		</div>
	</div>
</ng-template>

<ng-template #toolbarTpl>
	<div class="w-100 p-1-tb bg-280">
		<div class="w-100 border-box-wrapper bg-170 fl fl-ai-c fl-jc-fs p-0h-rl p-0h-tb br-1h">
			<div class="fl-fixed w-0 h-100 fl fl-ai-c fl-jc-fs ov-h">
				<div buttonIcon size="S">
					<div class="w-fs-icon h-fs-icon"></div>
				</div>
			</div>
			@if (!$loading()) {
				<div class="fl-adaptable ov-h fl fl-ai-c fl-jc-c fl-gap-2">
					<div class="fl-fixed fl fl-ai-c fl-jc-fs">
						<button
							buttonIcon
							[class.sidemenu-btn]="$sidebarVisible()"
							size="S"
							[active]="$sidebarVisible()"
							(click)="toggleSidebar()"
						>
							<i class="icon-sidebar"></i>
						</button>
					</div>

					<div class="fl-adaptable fl fl-ai-c fl-jc-c">
						<ng-container [ngTemplateOutlet]="separator"></ng-container>
						<div class="p-2-rl fl fl-ai-c fl-jc-fs fl-gap-0q ellipsis">
							<button
								buttonIcon
								size="S"
								[disabled]="$page() <= 1"
								(click)="decreasePage()"
							>
								<i class="icon-chevron chevron-left"></i>
							</button>
							<input
								#pageInput
								type="text"
								[inputValidator]="$removeEverythingExceptIntegers()"
								[(ngModel)]="$page"
								(keydown.arrowUp)="$event.preventDefault(); increasePage()"
								(keydown.arrowDown)="$event.preventDefault(); decreasePage()"
								class="w-sp-4 br-0t p-0h bg-280 talign-c"
								style="border: none"
							/>
							<span class="fc-800">/ {{ $maxPage() }}</span>
							<button
								buttonIcon
								size="S"
								[disabled]="$page() >= $maxPage()"
								(click)="increasePage()"
							>
								<i class="icon-chevron chevron-right"></i>
							</button>
						</div>

						<ng-container [ngTemplateOutlet]="separator"></ng-container>

						@if (!$smallScreen()) {
							<div class="p-2-rl fl fl-ai-c fl-jc-fs fl-gap-0q">
								<button buttonIcon size="S" (click)="zoomOut()">
									<i class="icon-minus"></i>
								</button>

								<div class="pos-rel">
									<select
										[(ngModel)]="$zoomValue"
										class="talign-c"
										style="color: transparent !important"
									>
										@for (zoomItem of $allZooms(); track zoomItem.key) {
											<option class="fc-800" [value]="zoomItem.value">
												{{ zoomItem.label }}
											</option>
										}
									</select>

									<div
										class="pos-abs pos-t-0 pos-l-0 w-100 h-100 fl fl-ai-c fl-jc-c fc-500 bg-280 br-0t"
										style="pointer-events: none"
									>
										{{ $zoomLabel() }}
									</div>
								</div>

								<button buttonIcon size="S" (click)="zoomIn()">
									<i class="icon-plus"></i>
								</button>
							</div>

							<ng-container [ngTemplateOutlet]="separator"></ng-container>
						}
					</div>

					<div class="fl-fixed fl fl-ai-c fl-jc-fe fl-gap-1">
						@if ($smallScreen()) {
							<!--  -->
							@if ($zoomValue() !== DEFAULT_ZOOM_LEVEL) {
								<div class="pos-rel fl fl-dir-c fl-ai-fs fl-jc-fs">
									<button buttonIcon size="S" (click)="resetZoom()">
										<i class="icon-zoom-in"></i>
									</button>
								</div>
							}
							<!--  -->
						}

						<button buttonIcon size="S" (click)="rotateRight()">
							<i class="icon-rotate-right"></i>
						</button>

						<button buttonIcon size="S" (click)="requestFullscreen()">
							@if ($fullscreenEnabled()) {
								<i class="icon-fullscreen-inside"></i>
							} @else {
								<i class="icon-fullscreen-outside"></i>
							}
						</button>
					</div>
				</div>
			}
		</div>
	</div>
</ng-template>

<ng-template #sidebarTpl>
	<div id="viewsManager" class="h-100 bg-280" style="top: 0px; border: 0px">
		<div class="w-100 h-100 fl fl-dir-c fl-ai-fs fl-jc-fs">
			<div class="fl-fixed w-100" style="pointer-events: none">
				<ng-container [ngTemplateOutlet]="toolbarTpl"></ng-container>
			</div>
			<div class="fl-adaptable w-100 ov-h pos-rel">
				<pdf-sidebar-content class="w-100"></pdf-sidebar-content>
			</div>
		</div>
		<div id="viewsManagerResizer" class="hidden"></div>
	</div>
</ng-template>

<div
	#pdfWrapper
	class="w-100 h-100 pos-rel"
	[class.p-1]="$fullscreenEnabled()"
	[class.bg-190]="$fullscreenEnabled()"
>
	@if ($renderPdf()) {
		<div class="w-100 h-100 fl fl-dir-c fl-ai-fs fl-jc-fs" [class.fl-gap-1]="!$hideToolbar()">
			<ngx-extended-pdf-viewer
				#viewer
				class="fl-adaptable ov-h"
				style="display: block; width: 100%; height: 100%"
				backgroundColor="var(--color-bg-190)"
				[showToolbar]="!$hideToolbar()"
				[customToolbar]="$hideToolbar() ? undefined : toolbarTpl"
				[customSidebar]="sidebarTpl"
				[minifiedJSLibraries]="false"
				[src]="$pdfUrl()"
				[authorization]="$authorization()"
				[textLayer]="false"
				[handTool]="false"
				[activeSidebarView]="1"
				[disableForms]="true"
				[httpHeaders]="$customHeaders()"
				[(zoom)]="$zoomValue"
				[(page)]="$page"
				[(sidebarVisible)]="$sidebarVisible"
				(currentZoomFactor)="$currentZoomFactor.set($event)"
				(annotationLayerRendered)="onAnnotationLayerRendered($event)"
				(pdfLoadingStarts)="onPdfStartsLoading()"
				(pdfLoaded)="onPdfLoaded($event)"
				(pdfLoadingFailed)="onPdfFailed()"
				(progress)="onProgress($event)"
			></ngx-extended-pdf-viewer>

			@if ($chunkToTranslate(); as chunkToTranslate) {
				<app-chunk-translator
					class="fl-fixed w-100"
					style="height: 200px"
					[chunkInfo]="chunkToTranslate"
					(close)="closeTranslation()"
				></app-chunk-translator>
			}
		</div>
	} @else {
		<div class="w-100 h-100 bg-190"></div>
	}

	<div
		class="pos-abs pos-t-0 pos-l-0 w-100 h-100 pos-rel fl fl-dir-c fl-ai-fs fl-jc-fs pe-none"
		style="z-index: 2"
	>
		@if (!$hideToolbar()) {
			<div class="w-100 fl-fixed invisible">
				<ng-container [ngTemplateOutlet]="toolbarTpl"></ng-container>
			</div>
		}
		<div class="pos-rel w-100 fl-adaptable ov-h fl fl-ai-c fl-jc-c br-1h ov-h">
			@if ($unsuported()) {
				<div class="w-100 fl fl-dir-c fl-ai-c fl-jc-c fl-gap-2 pe-all">
					<i
						class="icon-warning-white importance-8 fc-importance"
						style="font-size: calc(5 * var(--spacing))"
					></i>
					<p class="fc-400">The file type is not supported for the preview.</p>
				</div>
			} @else if ($showLoadingOverlay()) {
				<div class="pos-abs pos-t-0 pos-l-0 w-100">
					<div
						class="h-sp-0h br-0q"
						[style.width.%]="$loadingPercent()"
						style="
							background: linear-gradient(
								90deg,
								rgba(var(--color-primary-rgb), 0.2) 0%,
								rgba(var(--color-primary-rgb), 1) 100%
							);
						"
					></div>
				</div>

				<div class="w-100 fl fl-dir-c fl-ai-c fl-jc-c fl-gap-2">
					<i
						tenantMarkIconClass
						class="fc-primary"
						style="font-size: calc(5 * var(--spacing))"
					></i>
					<p class="fc-400">Loading file...</p>
				</div>
			} @else if ($failed()) {
				<div class="w-100 fl fl-dir-c fl-ai-c fl-jc-c fl-gap-2 pe-all">
					<i
						class="icon-cross-empty fc-warn"
						style="font-size: calc(5 * var(--spacing))"
					></i>
					<p class="fc-400">The file could not be loaded, please try again.</p>
					<button buttonOutlined (click)="retry()">Retry</button>
				</div>
			}
		</div>
	</div>
</div>
